import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Fragment } from 'react';

import { EditProfileForm } from '@/components/management/form/EditProfileForm';
import { AdministrationBody } from '@/components/management/layout/AdministrationBody';
import { AdministrationHeader } from '@/components/management/layout/AdministrationHeader';
import { useUserSuspenseQuery } from '@/hooks/useUserSuspenseQuery';
import { backendApiUsersUpdateMutation } from '@/modules/api/backend/@tanstack/react-query.gen';
import { useSnackbarStore } from '@/stores/useSnackbarStore';

export const Route = createFileRoute('/_authenticated/management/profile/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
  beforeLoad: () => ({ breadcrumb: null }),
});

function RouteComponent() {
  const { data: user } = useUserSuspenseQuery();

  const { openSnackbar } = useSnackbarStore((state) => state.actions);

  const { mutateAsync: mutateAsyncUpdate } = useMutation({
    ...backendApiUsersUpdateMutation(),
    meta: { invalidateQueries: false },
    onSuccess: () => {
      openSnackbar({
        color: 'success',
        message: 'Die Änderungen wurden erfolgreich gespeichert!',
      });
    },
    onError: () => {
      openSnackbar({
        color: 'error',
        message: 'Fehler beim Speichern.',
      });
    },
  });

  return (
    <Fragment>
      <AdministrationHeader formId="profileForm" label="Profil bearbeiten" />
      <AdministrationBody>
        <EditProfileForm
          initialValues={user}
          onSubmit={async (values) => {
            await mutateAsyncUpdate({
              path: { userId: user.id },
              body: {
                firstName: values.firstName,
                lastName: values.lastName,
                email: values.email,
                password: values.password,
              },
            });
          }}
        />
      </AdministrationBody>
    </Fragment>
  );
}
